import { useNavigate, Outlet } from "react-router-dom";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../../components/SpearParts/Layouts/SeachSection";
import SEO from "../../../components/SEO";
import "../../../App.css";

import Brand from "../../../components/SpearParts/Layouts/Brand";

import Catalogue from "../../../components/SpearParts/Layouts/Catalogue";
import { About } from "../../../components/SpearParts/Layouts/About";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { useEffect, useState } from "react";
import "./NewDashboard.css";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import Middle from "../../../components/SpearParts/Layouts/Middle";
import { NewAbout } from "../../../components/SpearParts/Layouts/NewAbout";

const NewDashboard = () => {
  const navigate = useNavigate();
  const [businessType, setBusinessType] = useState(
    sessionStorage.getItem("businessType") || ""
  );

  useEffect(() => {
    if (businessType) {
      if (businessType === "Engineering" || businessType === "Marine And Engineering") {
        navigate("/engineering-home");
      } else if (businessType === "Building") {
        navigate("/others-home");
      } else if (businessType === "Rental") {
        navigate("/rental-home");
      }
    }
  }, [businessType]);


  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    width: "360px",
    height: "100%",
    backgroundImage: "url(/images/bnr-before.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  const afterImageStyle = {
    content: '""',
    position: "absolute",
    right: 0,
    bottom: "50px",
    width: "200px",
    height: "38%",
    backgroundImage: "url(/images/bnr-after.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right bottom",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };

  return (
    <div>
      <div className="New-Dashboard" style={sectionStyle}>
        <div className="before-image" style={beforeImageStyle}></div>

        <div className="after-image" style={afterImageStyle}></div>

        <div className="new-dashboard-container">
          <SEO
            title="Spare Parts, Engineering , Building materials & Rental Equipment"
            description="Asia Parts - Leading supplier of quality spare parts, engineering components, and rental equipment. Browse our catalog and order online."
            canonical="https://asiapartsouq.com/"
            ogImage="https://asiapartsouq.com/images/home-og.jpg"
            ogUrl="https://asiapartsouq.com/"
          />
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <Middle />
          <div className="Catalogue-section">
            {" "}
            <Catalogue />
          </div>
        </div>
      </div>
      <div className="new-dashboard-container">
        <Brand />
        <NewAbout />
      </div>
    </div>
  );
};
export default NewDashboard;
